import { render, staticRenderFns } from "./VisaNoDetails.vue?vue&type=template&id=7925b78d&"
import script from "./VisaNoDetails.vue?vue&type=script&lang=js&"
export * from "./VisaNoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports